import React, { useState } from "react";
import { toast } from "react-toastify";
import { verifyDriverBackground } from "../apis/drivers/verify-driver-background";
import Button from "./Button";
import { twMerge } from 'tailwind-merge';

interface VerifyDriverBackgroundBtnProps {
  id: string;
  onSuccess: () => void;
  className?: string;
}

const VerifyDriverBackgroundBtn = ({
  id,
  onSuccess,
  className
}: VerifyDriverBackgroundBtnProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleBackgroundCheck = async () => {
    setIsLoading(true);
    const res = await verifyDriverBackground(id);
    if (res?.success) {
      onSuccess();
      toast(
        res?.data.statusCode || "Background check is requested successfully",
        {
          type: "success",
        }
      );
    } else {
      toast(
        res?.error.error ||
        "Something went wrong while requesting background check. Kindly try again later.",
        { type: "error" }
      );
    }
    setIsLoading(false);
  };

  return (
    <Button
      isLoading={isLoading}
      className={twMerge(`h-9 min-h-0 flex w-max px-2`, className)}
      onClick={handleBackgroundCheck}
    >
      Verify background
    </Button>
  );
};

export default VerifyDriverBackgroundBtn;
